import IncidentForm from "../../../../components/Forms/incidentForm";
import { TabOptions } from "../../../../types/fieldInstance.interface";

const Response = () => {
  return (
    <div>
      <IncidentForm tabTitle={TabOptions.Response} />
    </div>
  );
};

export default Response;
